import { useCallback, useEffect, useState } from "react";

import { getSupabaseClient } from "../providers/supabase/supabase";
import type { MfaAssuranceLevel, MfaFactors } from "./mfaAuthGuard";
import { hasVerifiedMfaFactor } from "./mfaAuthGuard";

type MfaStatus = {
  loading: boolean;
  factors: MfaFactors;
  currentLevel: MfaAssuranceLevel;
  nextLevel: MfaAssuranceLevel;
  hasVerifiedFactor: boolean;
  refresh: () => Promise<void>;
};

const emptyFactors: MfaFactors = { totp: [], phone: [] };

export function useMfaStatus(): MfaStatus {
  const [loading, setLoading] = useState(true);
  const [factors, setFactors] = useState<MfaFactors>(emptyFactors);
  const [currentLevel, setCurrentLevel] = useState<MfaAssuranceLevel>(null);
  const [nextLevel, setNextLevel] = useState<MfaAssuranceLevel>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    const supabase = getSupabaseClient();

    const [{ data: aalData }, { data: factorsData }] = await Promise.all([
      supabase.auth.mfa.getAuthenticatorAssuranceLevel(),
      supabase.auth.mfa.listFactors(),
    ]);

    setCurrentLevel(aalData?.currentLevel ?? null);
    setNextLevel(aalData?.nextLevel ?? null);
    setFactors({
      totp: factorsData?.totp ?? [],
      phone: factorsData?.phone ?? [],
    });
    setLoading(false);
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    loading,
    factors,
    currentLevel,
    nextLevel,
    hasVerifiedFactor: hasVerifiedMfaFactor(factors),
    refresh,
  };
}
